export enum PhotoDimensions {
  desktopWidth = 25,
}
